import { FormStepDataLayerReference } from '../types/global';

export const formStepDataLayerReference: FormStepDataLayerReference = {
  species: {
    funnelStageNumber: 1,
    includePet: true,
  },
  petDetails: {
    funnelStageNumber: 2,
    includePet: true,
  },
  petHistory: {
    funnelStageNumber: 3,
    includePet: true,
  },
  customerDetails: {
    funnelStageNumber: 4,
    includePet: true,
  },
  customerDeclarations: {
    funnelStageNumber: 5,
    includePet: true,
  },
  activityLevel: {
    funnelStageNumber: 4.5,
    includePet: true,
  },
  policyStartDate: {
    funnelStageNumber: 5,
    includePet: true,
  },
  coverLevel: {
    funnelStageNumber: 6,
    includePet: true,
  },
  fixedExcess: {
    funnelStageNumber: 7,
    includePet: true,
  },
  features: {
    funnelStageNumber: 8,
    includePet: true,
  },
  declaration: {
    funnelStageNumber: 9,
    includePet: true,
  },
  review: {
    funnelStageNumber: 10,
    includePet: true,
  },
  paymentMethod: {
    funnelStageNumber: 11,
    includePet: true,
  },
  paymentTransaction: {
    funnelStageNumber: 12,
    includePet: true,
  },
  confirmation: {
    funnelStageNumber: 13,
    includePet: true,
  },
};
